import { Typography } from "@mui/material";
import { useLocation } from "react-router-dom";

import { InnerBox } from "@/modules/irohana-components/elements/InnerBox";
import { ORGANIZATION_TABS } from "@/features/organization/constants/tabs";
import { text } from "@/theme/colors";

/**
 * Placeholder for tabs that are not implemented yet.
 * Per spec direction: when the tab is active, just render the tab name.
 */
export const OrganizationTabPlaceholder = () => {
  const location = useLocation();
  const tab = ORGANIZATION_TABS.find((item) => item.path === location.pathname);

  return (
    <InnerBox>
      <Typography variant="head20Bold" color={text.primary}>
        {tab?.label ?? ""}
      </Typography>
    </InnerBox>
  );
};
